// src/hooks/useServices.js
import { useState, useEffect } from 'react';
import { collection, onSnapshot } from 'firebase/firestore';
import { db } from '../firebase';

export const useServices = () => {
  const [services, setServices] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    setLoading(true);
    
    try {
      const unsubscribe = onSnapshot(
        collection(db, 'services'),
        (snapshot) => {
          const servicesData = snapshot.docs.map(doc => ({
            id: doc.id,
            ...doc.data()
          }));
          setServices(servicesData);
          setLoading(false);
          setError(null);
        },
        (error) => {
          console.error('Firestore error:', error);
          setError(error.message);
          setLoading(false);
          
          // Fallback do danych z local storage lub pliku JSON
          fetch('/api/services.json')
            .then(response => response.json())
            .then(data => {
              setServices(data.services);
              setError(null);
            })
            .catch(fallbackError => {
              console.error('Fallback error:', fallbackError);
              setError('Nie udało się załadować danych');
            });
        }
      );

      return () => unsubscribe();
    } catch (err) {
      console.error('Setup error:', err);
      setError(err.message);
      setLoading(false);
    }
  }, []);

  return { services, loading, error };
};